<template>
  <section class="contact-banner">
    <!-- Decoratief EV-bolt icoon rechtsboven -->
    <div class="deco" aria-hidden="true">
      <i class="bi bi-lightning-charge-fill"></i>
    </div>

    <div class="inner">
      <div class="content">
        <!-- Kop -->
        <div class="heading">
          <h2>Meer weten?</h2>
          <p>Onze specialisten helpen je graag verder</p>
        </div>

        <!-- Contactopties -->
        <div class="options">
          <a href="mailto:info@plug2charge.nl" class="option">
          <span class="option-icon"><i class="bi bi-envelope-fill"></i></span>
          <span class="option-body">
            <strong>Stuur een e‑mail</strong>
            <small>Antwoord binnen 1 werkdag</small>
          </span>
        </a>

        <a href="/klantenservice#livechat" class="option">
          <span class="option-icon"><i class="bi bi-chat-dots-fill"></i></span>
          <span class="option-body">
            <strong>Live chat</strong>
            <small>Direct in gesprek</small>
          </span>
        </a>

        <router-link to="/veelgestelde-vragen" class="option">
          <span class="option-icon"><i class="bi bi-question-circle-fill"></i></span>
          <span class="option-body">
            <strong>Veelgestelde vragen</strong>
            <small>Direct antwoord</small>
          </span>
          </router-link>
        </div>
      </div>

      <!-- Menselijk gezicht bij de CTA -->
      <img
        class="banner-photo"
        :src="'/wp-content/uploads/2026/07/thomas_batterij-removebg-preview.png?w=760'"
        alt="Medewerker van Plug2Charge met een draagbare thuisbatterij"
        loading="lazy"
        width="425"
        height="586"
      />
    </div>
  </section>
</template>

<script setup></script>

<style scoped>
.contact-banner {
  position: relative;
  background: #FFD500;
  overflow: hidden;
  padding: 3rem 1.5rem;
}

.deco {
  position: absolute;
  right: -1rem;
  top: 50%;
  transform: translateY(-50%);
  font-size: 10rem;
  color: rgba(0,0,0,.06);
  line-height: 1;
  pointer-events: none;
  user-select: none;
}

.inner {
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
}

.content {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 3rem;
  flex-wrap: wrap;
}

/* Vrijstaande medewerker-foto: staat op de onderrand van de gele band */
.banner-photo {
  display: none;               /* verborgen op mobiel/tablet - zie media query */
  align-self: flex-end;
  height: 210px;
  width: auto;
  margin-bottom: -3rem;        /* compenseert de padding zodat 'ie flush staat */
  flex-shrink: 0;
  filter: drop-shadow(0 8px 18px rgba(0,0,0,.18));
}
@media (min-width: 1024px) {
  .banner-photo { display: block; }
}

.heading {
  flex: 1;
  min-width: 180px;
}
.heading h2 {
  font-size: clamp(1.5rem, 3vw, 2rem);
  font-weight: 900;
  color: #111;
  margin-bottom: .25rem;
  line-height: 1.1;
}
.heading p {
  font-size: .9375rem;
  color: rgba(0,0,0,.55);
  margin: 0;
}

.options {
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.option {
  display: flex;
  align-items: center;
  gap: .875rem;
  background: rgba(0,0,0,.08);
  border-radius: 14px;
  padding: 1rem 1.375rem;
  text-decoration: none;
  transition: background .15s;
  min-width: 180px;
}
.option:hover {
  background: rgba(0,0,0,.14);
}

.option-icon {
  width: 40px;
  height: 40px;
  background: #111;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFD500;
  font-size: 1.1rem;
  flex-shrink: 0;
}

.option-body {
  display: flex;
  flex-direction: column;
  gap: .1rem;
}
.option-body strong {
  font-size: .9rem;
  font-weight: 700;
  color: #111;
  line-height: 1.2;
}
.option-body small {
  font-size: .75rem;
  color: rgba(0,0,0,.55);
  line-height: 1.3;
}

@media (max-width: 640px) {
  .inner   { flex-direction: column; gap: 1.25rem; }
  .heading { min-width: 0; }
  .options { gap: .75rem; flex-direction: column; }
  .option  { min-width: 0; width: 100%; padding: .875rem 1rem; }
}
</style>
